<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Magazzino</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Magazzino</li>
            <li class="breadcrumb-item active">Movimentazione articoli</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          Movimentazioni articoli
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">

        <dx-data-grid
          id="gridContainer"
          [dataSource]="dataSource"
          [showBorders]="true"
          [focusedRowEnabled]="false"
          [columnAutoWidth]="true"
          [columnHidingEnabled]="true"
          [showColumnLines]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="true"
          (onInitNewRow)="onInitNewRow()"
          (onExporting)="onExporting($event)"
          >

          <dxo-export [enabled]="true"></dxo-export>
          <dxo-editing
            mode="popup"
            [allowAdding]="false"
            [allowUpdating]="false"
            [allowDeleting] ="true"
            [useIcons]="true"
            >
            <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
          </dxo-editing>

          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
          <dxi-column
            dataField="id"
            [formItem]="{ visible: false }"
            [visible]="false"
            [allowEditing]="false"
            >
          </dxi-column>
          <dxi-column
            dataField="data"
            format="dd/MM/yyyy"
            dataType="date">
            <dxi-validation-rule type="required" message="Selezionare la data"></dxi-validation-rule>
          </dxi-column>
          <dxi-column
            dataField="utenteStr"
            [formItem]="{ visible: false }"
            [visible]="true"
            [allowEditing]="false">
          </dxi-column>

          <dxi-column
            dataField="idArticolo"
            caption="Articolo">
            <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr">

            </dxo-lookup>
            <dxi-validation-rule type="required" message="Selezionare l'articolo"></dxi-validation-rule>
          </dxi-column>
          @if (gestMatricole) {
            <dxi-column
              dataField="idArticoloMatricola"
              caption="Matricola">
              <dxo-lookup [dataSource]="listArticoliMatricola" valueExpr="id" displayExpr="matricola">
              </dxo-lookup>
            </dxi-column>
          }
          <dxi-column
            dataField="idCausale"
            caption="Causale">
            <dxo-lookup [dataSource]="listCaus" valueExpr="id" displayExpr="descrizione">

            </dxo-lookup>
            <dxi-validation-rule type="required" message="Selezionare la causale"></dxi-validation-rule>
          </dxi-column>
          <dxi-column
            dataField="note">
          </dxi-column>
          <dxi-column
            dataField="qta"
            dataType="number"
            [formItem]="{ visible: true }"
            [visible]="false"
            [allowEditing]="true">
            <dxi-validation-rule type="required" message="Inserire la quantità"></dxi-validation-rule>
          </dxi-column>
          <dxi-column
            dataField="qtaRealValue"
            caption="Qta"
            dataType="string"
            [formItem]="{ visible: false }"
            [visible]="true"
            [allowEditing]="false"
            cellTemplate="qtaTemplate">

          </dxi-column>
          <div *dxTemplate="let d of 'qtaTemplate'" [class]="{'inc' :d.data.qtaRealValue > 0, 'dec': d.data.qtaRealValue <= 0}">
            <div class="diff">{{abs(d.data.qtaRealValue) | number:'1.2-2'}}</div>
          </div>


        </dx-data-grid>

      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>

  <!--
  <h2 class="content-block">Movimenti magazzino DPI</h2>
  <div class="content-block">
    -->
  </div>

  @if (popupNuovoMovimentoMagVisible) {
    <app-popup-add-mov-magazzino (popupAddMovMagazzinoEventEmitter)="onPopupNuovoMovimentoEvent($event)"></app-popup-add-mov-magazzino>
  }
